import { useEffect, useMemo } from 'react'
import { studentProfileBuilderStore } from 'shared/stores/studentProfileBuilderStore'
import { calculateProfileCompleteness } from './calculateProfileCompleteness'
import { fetchStudentProfile } from 'api/users'
import { classroomStore } from 'pages/Classroom/model/classroomStore'
import { shouldRefetchDetails } from 'pages/Classroom/utils/taskFreshness'

export const useProfileBuildingSubmission = ({ assignment, student }) => {
	const studentId = student?.id
	const taskId = assignment?.id || assignment?.task_id

	useEffect(() => {
		if (!studentId) return
		const meta = classroomStore.getTaskFreshnessMeta({ taskId, studentId })
		if (!shouldRefetchDetails({ type: 'profile_building', meta })) return
		fetchStudentProfile(studentId)
			.then(data => {
				const profileData = data?.profile_data || data?.profileData || null
				studentProfileBuilderStore.upsertProfile(studentId, profileData, data?.updated_at)
				classroomStore.markTaskDetailsLoaded({
					taskId,
					studentId,
					type: 'profile_building',
				})
			})
			.catch(error => {
				console.error('Error fetching profile builder:', error)
			})
	}, [studentId, taskId])

	const profileData = useMemo(() => {
		if (!studentId) return null
		const profile = studentProfileBuilderStore.getProfile(studentId)
		return profile?.profileData || null
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [studentId, studentProfileBuilderStore.profiles])

	const completionPercentage = useMemo(() => {
		if (!profileData) return 0
		return calculateProfileCompleteness(profileData)
	}, [profileData])

	const isLoading = studentProfileBuilderStore.isLoading

	// Get response text from student data
	const responseText =
		student?.response_text ||
		student?.responseText ||
		student?.assignmentData?.response_text ||
		assignment?.students?.find(s => s.id === student?.id)?.response_text ||
		''

	return {
		completionPercentage,
		isLoading,
		responseText,
		hasResponse: Boolean(responseText && responseText.trim()),
	}
}

export default useProfileBuildingSubmission
